class TiposPagamentoModel {
    
    /**
     * 
     * @param {Array<TiposPagamentoModel>} credito 
     * @param {Array<TiposPagamentoModel>} debito 
     * @param {Array<TiposPagamentoModel>} padrao 
     */
    constructor(credito, debito, padrao) {
        this.credito = credito;
        this.debito = debito;
        this.padrao = padrao;
    }

    fromJson(json) {
        this.credito = []
        this.debito = []
        this.padrao = []
        if (json["credito"] != null) {
            for (let i = 0; i < json['credito'].length; i++) {
                this.credito.push(new CadaPagamentoModel().fromJson(json['credito'][i]));
            }
        }
        if (json["debito"] != null) {
            for (let i = 0; i < json['debito'].length; i++) {
                this.debito.push(new CadaPagamentoModel().fromJson(json['debito'][i]));
            }
        }
        if (json["padrao"] != null) {
            for (let i = 0; i < json['padrao'].length; i++) {
                this.padrao.push(new CadaPagamentoModel().fromJson(json['padrao'][i]));
            }
        }
        return this
    }

}

export default TiposPagamentoModel

class CadaPagamentoModel {
    constructor(id, nome) {
        this.id = id;
        this.nome = nome;
    }

    fromJson(json) {
        this.id = json["id"]
        this.nome = json["nome"]
        return this
    }
}